export default __webpack_public_path__ + "static/media/desktop.1b0e2c48.jpg";